import AbstractHandler from '@/language/handlers/AbstractHandler';
import Language from '@/language/Language';

export default class LocalizedHTMLTagHandler extends AbstractHandler {
    handle(language: Language): void {
        document.querySelector('html')?.setAttribute('lang', language.code);

        super.handle(language);
    }
}
